module.exports = __webpack_public_path__ + "img/paarfoto_regenschirm-kuss_ocular.11ae95ca.jpg";